import { render, staticRenderFns } from "./PatientsTable.vue?vue&type=template&id=560b1bfe&scoped=true"
import script from "./PatientsTable.vue?vue&type=script&lang=js"
export * from "./PatientsTable.vue?vue&type=script&lang=js"
import style0 from "./PatientsTable.vue?vue&type=style&index=0&id=560b1bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560b1bfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
